import { Action } from 'redux'

import ClientPassengerToBeDeletedInterface from '../../interfaces/client/PassengerToBeDeleted'

import { RECEIVE_DELETE_PASSENGERS } from '../../actions/passengers/receiveDeletePassengers'
import { SET_PASSENGERS_TO_BE_DELETED } from '../../actions/deletePassengers/setPassengersToBeDeleted'
import { RESET_PASSENGERS_TO_BE_DELETED } from '../../actions/deletePassengers/resetPassengersToBeDeleted'
import { SELECT_PASSENGER_FOR_DELETION } from '../../actions/deletePassengers/selectPassengerForDeletion'
import { DESELECT_PASSENGER_FOR_DELETION } from '../../actions/deletePassengers/deselectPassengerForDeletion'
import { SELECT_ALL_PASSENGERS_FOR_DELETION } from '../../actions/deletePassengers/selectAllPassengersForDeletion'
import { DESELECT_ALL_PASSENGERS_FOR_DELETION } from '../../actions/deletePassengers/deselectAllPassengersForDeletion'

import normalizeData from '../../utils/normalizeData'
import { DISABLE_DELETE_PASSENGERS } from '../../actions/deletePassengers/disableDeletePassengers'

export interface PassengersToBeDeleted {
  byId: {
    [id: string]: ClientPassengerToBeDeletedInterface
  }
  allIds: string[]
  passengersSelectedForDeletion: string[]
}

interface PassengersToBeRemovedActionInterface extends Action {
  type: string
  passengers: ClientPassengerToBeDeletedInterface[]
  passengerId: string
  passengerIds: string[]
}

export const initialState: PassengersToBeDeleted = {
  byId: {},
  allIds: [],
  passengersSelectedForDeletion: [],
}

export default (
  state = initialState,
  action: PassengersToBeRemovedActionInterface = {
    type: '',
    passengers: [],
    passengerId: '',
    passengerIds: [],
  }
) => {
  switch (action.type) {
    case SET_PASSENGERS_TO_BE_DELETED:
      const byId = normalizeData(action.passengers)
      const allIds = action.passengers.map(
        (passengerToBeDeleted: ClientPassengerToBeDeletedInterface) =>
          passengerToBeDeleted.id
      )

      return {
        ...state,
        byId,
        allIds,
      }

    case SELECT_PASSENGER_FOR_DELETION:
      return {
        ...state,
        passengersSelectedForDeletion: [
          ...state.passengersSelectedForDeletion,
          action.passengerId,
        ],
      }

    case DESELECT_PASSENGER_FOR_DELETION:
      return {
        ...state,
        passengersSelectedForDeletion: state.passengersSelectedForDeletion.filter(
          (passengerId: string) => passengerId !== action.passengerId
        ),
      }

    case DISABLE_DELETE_PASSENGERS:
    case DESELECT_ALL_PASSENGERS_FOR_DELETION:
      return {
        ...state,
        passengersSelectedForDeletion: [],
      }

    case SELECT_ALL_PASSENGERS_FOR_DELETION:
      return {
        ...state,
        passengersSelectedForDeletion: [...action.passengerIds],
      }

    case '@@router/LOCATION_CHANGE':
    case RECEIVE_DELETE_PASSENGERS:
    case RESET_PASSENGERS_TO_BE_DELETED:
      return initialState

    default:
      return state
  }
}
